import {AfterViewInit, Component, OnInit} from '@angular/core';
import {BaseComponent} from '../../../shared/commons/base-component/base.component';
import {HelpersService} from '../../../core/helpers/helpers.service';

@Component({
  selector: 'app-base-page',
  templateUrl: './base-page.component.html',
  styleUrls: ['./base-page.component.css']
})
export class BasePageComponent extends BaseComponent implements OnInit, AfterViewInit {

  constructor(helpers: HelpersService) {
    super(helpers);
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/commons/base-page/base-page.component.ts